import { jsx } from "react/jsx-runtime";
import { isWeb } from "@tamagui/constants";
import { Children, cloneElement, isValidElement } from "react";
import { variableToString } from "../createVariable";
import { ThemeManagerContext } from "../helpers/ThemeManagerContext";
import { useServerRef } from "../hooks/useServerHooks";
import { useChangeThemeEffect } from "../hooks/useTheme";
import { ThemeDebug } from "./ThemeDebug";
function Theme(props) {
  if (props.disable) {
    return props.children;
  }
  const isRoot = !!props["_isRoot"];
  const themeState = useChangeThemeEffect(props, isRoot);
  let children = props["disable-child-theme"] ? Children.map(
    props.children,
    (child) => cloneElement(child, { ["data-disable-theme"]: true })
  ) : props.children;
  if (process.env.NODE_ENV === "development") {
    if (props.debug === "visualize") {
      children = /* @__PURE__ */ jsx(ThemeDebug, { themeState, themeProps: props, children });
    }
  }
  return useThemedChildren(themeState, children, props, isRoot);
}
function useThemedChildren(themeState, children, props, isRoot = false) {
  const { themeManager, className, theme, isNewTheme } = themeState;
  const { shallow, forceClassName } = props;
  const hasEverThemed = useServerRef(false);
  if (isNewTheme) {
    hasEverThemed.current = true;
  }
  const shouldRenderChildrenWithTheme = isNewTheme || hasEverThemed.current || forceClassName || isRoot;
  if (!shouldRenderChildrenWithTheme) {
    return children;
  }
  if (shallow && themeManager) {
    let next = Children.toArray(children);
    next = next.map((child) => {
      return isValidElement(child) ? cloneElement(
        child,
        void 0,
        /* @__PURE__ */ jsx(Theme, { name: themeManager.state.parentName, children: child.props.children })
      ) : child;
    });
  }
  const wrapped = /* @__PURE__ */ jsx(ThemeManagerContext.Provider, { value: themeManager, children });
  if (forceClassName === false) {
    return wrapped;
  }
  if (isWeb && !props.passPropsToChildren) {
    const themeColor = theme && isNewTheme ? variableToString(theme.color) : "";
    const colorStyle = themeColor ? {
      color: themeColor
    } : void 0;
    return /* @__PURE__ */ jsx("span", { className: `${className || ""} _dsp_contents is_Theme`, style: colorStyle, children: wrapped });
  }
  return wrapped;
}
export {
  Theme,
  useThemedChildren
};
//# sourceMappingURL=Theme.js.map
